import $ from 'jquery'
import instantsearch from 'instantsearch.js'
import { highlight } from 'instantsearch.js/es/helpers'
import { configure, index } from 'instantsearch.js/es/widgets'
import { history } from 'instantsearch.js/es/lib/routers'
import { connectSearchBox, connectMenu } from 'instantsearch.js/es/connectors'
import { connectHits } from 'instantsearch.js/es/connectors'
import {
  algoliaAppId,
  algoliaApiKey,
  trainingSearchIndex,
  trainingSearchSuggestionsIndex,
} from './variables'
import { training, noResult, allTrainings } from './templates'
import { trainingsSearch } from './pages/trainings'
import { liteClient } from 'algoliasearch/lite';

// eslint-disable-next-line no-undef
const { __ } = wp.i18n

// eslint-disable-next-line no-undef
const object = vnObject

const searchClient = liteClient(algoliaAppId, algoliaApiKey)

const headerSearch = instantsearch({
  indexName: trainingSearchIndex,
  searchClient,
  insights: true,
  routing: {
    router: history({
      push(url) {
        window.history.pushState({}, '', url)
        createArchiveUrl(this.getLocation().search)
      },
    }),
  },
})

const trainingItem = ({ hits, sendEvent, widgetParams }) => {
  const container = document.querySelector(widgetParams.container)

  container.innerHTML = `
    <div class="grid">
      ${
        hits.length
          ? hits.map((item) => training(item, highlight)).join('')
          : noResult
      }
      ${allTrainings}
    </div>
  `

  container
    .querySelectorAll('.feed-training__wrapper')
    .forEach((element, index) => {
      element.addEventListener('click', (event) => {
        sendEvent('click', hits[index], 'Training Clicked')
      })
    })
}

const suggestionItem = ({ widgetParams, hits }) => {
  const container = document.querySelector(widgetParams.container)

  container.innerHTML = `<ul>
    ${hits
      .map((hit) => {
        return `
          <li><a href="${
            object.trainingsPage
          }?${trainingSearchIndex}${encodeURI(`[query]=${hit.query}`)}">${
            hit._highlightResult.query.value
          }</a></li>
          `
      })
      .join('')}
  </ul>`
}

const suggestionItems = connectHits(suggestionItem)

const trainingItems = connectHits(trainingItem)

const renderSearchBox = (renderOptions, isFirstRender) => {
  const { query, refine, clear, isSearchStalled, widgetParams } = renderOptions
  const container = document.querySelector(widgetParams.container)

  if (isFirstRender) {
    const input = document.createElement('input')
    input.type = 'search'
    input.placeholder = widgetParams.placeholder

    container.insertAdjacentHTML('beforeend', object.loader)

    const reset = document.createElement('button')
    reset.type = 'reset'
    reset.insertAdjacentHTML('beforeend', '<i class="vn-icons-close"></i>')

    const submit = document.createElement('button')
    submit.type = 'submit'
    submit.insertAdjacentHTML('beforeend', '<i class="vn-icons-search"></i>')

    input.addEventListener('input', (event) => {
      refine(event.target.value)

      if (trainingsSearch !== undefined) {
        trainingsSearch.setUiState({
          [trainingSearchIndex]: {
            query: event.target.value,
          },
        })
      }
    })

    reset.addEventListener('click', () => {
      clear()

      if (trainingsSearch !== undefined) {
        trainingsSearch.setUiState({
          [trainingSearchIndex]: {
            query: '',
          },
        })
      }
    })

    container.appendChild(input)
    container.appendChild(reset)
    container.appendChild(submit)
  }

  container.querySelector('input').value = query
  container.querySelector('.vn-loader').hidden = !isSearchStalled
}

const customSearchBox = connectSearchBox(renderSearchBox)

const renderMenu = (renderOptions, isFirstRender) => {
  const { items, widgetParams } = renderOptions
  const container = document.querySelector(widgetParams.container)

  if (isFirstRender) {
    const ul = document.createElement('ul')

    container.appendChild(ul)
  }

  container.querySelector('ul').innerHTML = items
    .map((item) => {
      let url = ''
      let label = item.label

      if ('menu' === widgetParams.widget) {
        url = `${object.trainingsPage}?${trainingSearchIndex}${encodeURI(
          `[${widgetParams.widget}][${widgetParams.attribute}]=${item.value}`
        )}`
      }

      if ('refinementList' === widgetParams.widget) {
        url = `${object.trainingsPage}?${trainingSearchIndex}${encodeURI(
          `[${widgetParams.widget}][${widgetParams.attribute}][0]=${item.value}`
        )}`
      }

      if ('job_sheets.urlName' === widgetParams.attribute) {
        const urlName = item.value.split('|')
        label = urlName[0]
        url = urlName[1]
      }

      return `
        <li>
          <a
            href="${url}"
            class="${widgetParams.itemClass}"
          >
            ${label}
          </a>
        </li>
      `
    })
    .join('')
}

const customMenu = connectMenu(renderMenu)

headerSearch.addWidgets([
  customSearchBox({
    container: '.header-search-handler',
    placeholder: __('Diploma, profession, training...', 'vn'),
    showLoadingIndicator: false,
  }),

  trainingItems({
    container: '.header-search-hits',
  }),

  customMenu({
    container: '.header-search-diplomas',
    attribute: 'diplomas.name',
    sortBy: ['name'],
    itemClass: 'pill',
    widget: 'menu',
  }),

  customMenu({
    container: '.header-search-post-types',
    attribute: 'post_type.name',
    sortBy: ['name'],
    itemClass: 'pill',
    widget: 'menu',
  }),

  customMenu({
    container: '.header-search-branches',
    attribute: 'training_branches.name',
    sortBy: ['name'],
    itemClass: 'pill',
    widget: 'refinementList',
  }),

  customMenu({
    container: '.header-search-jobs',
    attribute: 'job_sheets.urlName',
    sortBy: ['name'],
    itemClass: 'ais-Menu-link',
    widget: 'refinementList',
  }),

  configure({
    hitsPerPage: 3,
  }),

  index({
    indexName: trainingSearchSuggestionsIndex,
  }).addWidgets([
    suggestionItems({
      container: '.header-search-suggestions',
    }),
  ]),
])

headerSearch.start()

headerSearch.on('render', () => {
  const search = document.querySelector('.header-search-handler')
  if (search) search.style.visibility = 'visible'
})

const createArchiveUrl = (urlParams) => {
  const partEl = document.querySelector('.header-search')
  const urlEl = document.querySelector('.all-trainings')
  const formEL = document.querySelector('.search-entry')
  const origUrl = urlEl.getAttribute('data-orig-href')

  urlEl.setAttribute('href', origUrl + urlParams)
  formEL.setAttribute('action', origUrl + urlParams)

  if (urlParams) {
    partEl.classList.add('has-result')
  } else {
    partEl.classList.remove('has-result')
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const urlParams = window.location.search
  if (urlParams.includes(`?${trainingSearchIndex}`)) {
    createArchiveUrl(urlParams)
  }
})

$('.search-entry').on('submit', function (e) {
  e.preventDefault()
  window.location.href = $(this).attr('action')
})

$(document).on('click', '.header-search-suggestions li a', function (e) {
  if ($('body').hasClass('page-template-page-template-trainings')) {
    e.preventDefault()

    const text = $(this).text()
    headerSearch.helper.setQuery(text).search()
    trainingsSearch.helper.setQuery(text).search()
  }
})

$(document).on('focus', '.header-search input[type=search]', function () {
  $('body').addClass('header-search-active').css('overflow', 'hidden')
  $('.hamburger').addClass('is-active')
})

$('.part-header-search-wrapper').on('click', function (e) {
  if (e.target === $(this)[0]) {
    $('body').removeClass('header-search-active').css('overflow', '')
    $('.hamburger').removeClass('is-active')
  }
})

$(document).on('focus', '.search-entry input[type=search]', function () {
  $('body').addClass('search-active')
})

$('.search-mobile-opener').on('click', function () {
  $('body').addClass('search-active')
  $('body').removeClass('trainings-filter-active')
  $('body').removeClass('training-filter-active')
  $('body').removeClass('menu-active')
})

$('.search-entry').on('click', function (e) {
  if (e.target === this && window.matchMedia('(min-width: 992px)').matches) {
    $('body').removeClass('search-active')
  }
})

$(document).on(
  'click',
  '.header-search-handler button[type=reset]',
  function () {
    $('body').removeClass('search-active')
  }
)

export { headerSearch, createArchiveUrl }
